import {
  PermissionKey,
  GrantTypeLabel,
  statusOptions,
  playStatusOptions,
} from '@/common/permission'
import _ from 'lodash'
import {
  freeList,
  testList,
} from '@/views/producer/common-template/selling-strategy.js'
import { fetchGmakerTemplateList } from '@/api/gmaker/template'
import { fetchGrantOptions } from '@/api/grant/grant'

export default {
  data() {
    return {
      templateList: [],
      optionChannels: [],
      operatorOptions: [],
    }
  },
  computed: {
    formItemList() {
      return [
        {
          type: 'input',
          prop: 'adv_id',
          params: {
            clearable: true,
            placeholder: '请输入广告主ID',
          },
        },
        {
          prop: 'adv_ids',
          type: 'business',
          subtype: 'advertiser-selector',
          params: {
            multiple: true,
            filterable: true,
            collapseTags: true,
            style: 'width: 220px;',
            class: 'search-filter-select',
          },
        },
        {
          type: 'select',
          prop: 'status',
          params: {
            placeholder: '请选择状态',
            clearable: true,
            filterable: true,
            options: _.map(statusOptions, (v, k) => {
              return {
                label: v,
                value: k,
              }
            }),
          },
        },
        {
          type: 'select',
          prop: 'template_ids',
          params: {
            multiple: true,
            filterable: true,
            'collapse-tags': true,
            remote: true,
            clearable: true,
            remoteMethod: (query) => {
              return this.getTemplateList({
                name: query,
              })
            },
            placeholder: '请选择模板',
            options: this.templateList,
          },
        },
        {
          type: 'select',
          prop: 'channel_ids',
          params: {
            clearable: true,
            multiple: true,
            filterable: true,
            'collapse-tags': true,
            placeholder: '请选择授权渠道',
            options: this.optionChannels,
          },
        },
        {
          type: 'select',
          prop: 'grant_types',
          params: {
            placeholder: '订阅类型',
            clearable: true,
            multiple: true,
            filterable: true,
            options: _.map(GrantTypeLabel, (v, k) => {
              return {
                label: v,
                value: Number(k),
              }
            }),
          },
        },
        {
          type: 'select',
          prop: 'plan_ids',
          params: {
            multiple: true,
            filterable: true,
            'collapse-tags': true,
            remote: true,
            clearable: true,
            remoteMethod: (query) => {
              return this.getPlanList({
                name: query,
              })
            },
            placeholder: '套餐名称',
            options: this.planList,
          },
        },
        {
          type: 'select',
          prop: 'free',
          params: {
            placeholder: '是否付费',
            clearable: true,
            options: freeList,
          },
        },
        {
          type: 'select',
          prop: 'permissions',
          params: {
            placeholder: '授权功能',
            multiple: true,
            'collapse-tags': true,
            options: [
              { label: '可玩换肤编辑', value: PermissionKey.gm },
              { label: '可玩自由编辑', value: PermissionKey.ps },
              { label: '授权视频普通制作', value: PermissionKey.ve },
              { label: '授权录屏工具', value: PermissionKey.vrec },
            ],
          },
        },
        {
          type: 'select',
          prop: 'is_test',
          params: {
            placeholder: '是否测试账号',
            clearable: true,
            options: testList,
          },
        },
        {
          type: 'select',
          prop: 'admin_ids',
          params: {
            placeholder: '最后操作人',
            multiple: true,
            filterable: true,
            'collapse-tags': true,
            remote: true,
            clearable: true,
            remoteMethod: (query) => {
              return this.getOperator(query)
            },
            options: this.operatorOptions,
          },
        },
      ]
    },
    rechargeFormItemList() {
      return {
        keyword: {
          type: 'input',
          prop: 'keyword',
          params: {
            clearable: true,
            placeholder: '请输入3s用户名',
          },
        },
        time: {
          type: 'date-picker',
          subtype: 'daterange',
          prop: 'time',
          class: 'date-picker',
          params: {
            clearable: true,
            format: 'yyyy-MM-dd',
            valueFormat: 'yyyy-MM-dd',
            startPlaceholder: '支付开始时间',
            endPlaceholder: '支付结束时间',
            pickerOptions: {
              disabledDate(time) {
                return time.getTime() > Date.now()
              },
              shortcuts: [
                {
                  text: '最近三天',
                  onClick(picker) {
                    const end = new Date()
                    const start = new Date()
                    start.setTime(start.getTime() - 3600 * 1000 * 24 * 3)
                    picker.$emit('pick', [start, end])
                  },
                },
                {
                  text: this.$t('form.pastWeek'),
                  onClick(picker) {
                    const end = new Date()
                    const start = new Date()
                    start.setTime(start.getTime() - 3600 * 1000 * 24 * 7)
                    picker.$emit('pick', [start, end])
                  },
                },
                {
                  text: '最近半个月',
                  onClick(picker) {
                    const end = new Date()
                    const start = new Date()
                    start.setTime(start.getTime() - 3600 * 1000 * 24 * 15)
                    picker.$emit('pick', [start, end])
                  },
                },
              ],
            },
          },
        },
        status: {
          type: 'select',
          prop: 'status',
          params: {
            placeholder: '支付状态',
            multiple: true,
            options: _.map(playStatusOptions, (v, k) => {
              return {
                label: v,
                value: Number(k),
              }
            }),
          },
        },
        money_min: {
          type: 'input',
          prop: 'money_min',
          params: {
            clearable: true,
            placeholder: '支付金额最小值',
          },
        },
        money_max: {
          type: 'input',
          prop: 'money_max',
          params: {
            clearable: true,
            placeholder: '支付金额最大值',
          },
        },
        is_test: {
          type: 'select',
          prop: 'is_test',
          params: {
            clearable: true,
            placeholder: '是否测试账号',
            options: testList,
          },
        },
      }
    },
  },
  methods: {
    async getTemplateList(params) {
      const res = await fetchGmakerTemplateList({ ...params, is_active: 1 })
      this.templateList = [
        {
          value: '-1',
          label: '全部',
        },
      ].concat(
        (_.get(res, 'data.data.list') || []).map((item) => ({
          ...item,
          value: item.id.toString(),
          label: item.name,
        })),
      )
    },
    async getOperator(name) {
      const res = await fetchGrantOptions({
        option_type: 'operator',
        name: name || '',
      })

      this.operatorOptions = (_.get(res, 'data.data.list') || []).map(
        (item) => ({
          ...item,
          value: String(item.id),
          label: item.name,
        }),
      )
    },
    async getOptionChannels() {
      const useCache = true
      const res = await this.$store.dispatch('config/getCommonConfig', {
        useCache,
        names: ['channels'],
      })
      this.optionChannels = [
        {
          id: '-1',
          value: '-1',
          label: '全部',
        },
      ].concat(
        (_.get(res, 'channels') || []).map((item) => ({
          ...item,
          value: item.id.toString(),
          label: item.name,
        })),
      )
    },
  },
}
